<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 202.447 245.358"
    aria-labelledby="Energy Icon"
    role="presentation"
  >
    <title
      id="Energy Icon"
      lang="en"
    >Energy Icon</title>
    <g  id="Group_3335" data-name="Group 3335" transform="translate(0)">
      <g  id="Group_3334" data-name="Group 3334">
        <g  id="Group_3333" data-name="Group 3333">
          <path :fill="iconColor" id="Path_4272" data-name="Path 4272" d="M901.219,1238.371H858.532L891.1,1156.94a9.429,9.429,0,0,0-8.755-12.94H816.288a9.44,9.44,0,0,0-8.884,6.266l-47.184,132.117a9.42,9.42,0,0,0,8.884,12.606H811.79l-32.569,81.43a9.434,9.434,0,0,0,15.924,9.64l113.242-132.116a9.438,9.438,0,0,0-7.169-15.573ZM817.909,1330.5l16.57-41.443a9.429,9.429,0,0,0-8.755-12.94H782.5l40.438-113.242h45.47l-32.569,81.431a9.43,9.43,0,0,0,8.756,12.938H880.7Z" transform="translate(-759.669 -1144)"/>
        </g>
      </g>
    </g>
    <g id="Group_3336" data-name="Group 3336" transform="translate(118.172 151.416)">
      <path v-show="active" :fill="iconColor" id="Path_4273" data-name="Path 4273" d="M939.772,1374.06l-4.338-11.4H898.5l-4.337,11.647q-2.543,6.82-4.338,9.2t-5.887,2.385a8.632,8.632,0,0,1-6.134-2.542,7.774,7.774,0,0,1-2.665-5.762,12.907,12.907,0,0,1,.619-3.843q.619-1.981,2.046-5.513l23.238-58.993q.99-2.539,2.385-6.1a30.994,30.994,0,0,1,2.974-5.917,12.086,12.086,0,0,1,4.153-3.81,12.714,12.714,0,0,1,6.351-1.457,12.864,12.864,0,0,1,6.414,1.457,12.329,12.329,0,0,1,4.151,3.749,26.277,26.277,0,0,1,2.664,4.925q1.086,2.635,2.757,7.033l23.734,58.62q2.789,6.693,2.788,9.729a8.055,8.055,0,0,1-2.633,5.794,8.663,8.663,0,0,1-6.353,2.633,8.237,8.237,0,0,1-3.719-.775,7.59,7.59,0,0,1-2.6-2.105,19.488,19.488,0,0,1-2.263-4.091Q940.64,1376.17,939.772,1374.06Zm-36.438-25.218h27.142l-13.7-37.491Z" transform="translate(-875.14 -1291.955)"/>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    active:{
      type: Boolean,
      default: false
    }
  }
}
</script>